import { I18n } from '@aws-amplify/core';
import { message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { QUERY_KEYS } from '@/utils/query-keys';
import { BeraV2Service } from '@/infra/services/bera-v2';

import type { Response } from '@/types';

export interface DeleteBeraJobSummaryParams {
	id: string;
	organization_id: string;
	company_id: string;
}

const Service = BeraV2Service.getInstance();

export function useDeleteBeraJobSummary() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: DeleteBeraJobSummaryParams) => Service.removeJobSummary(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_BERA_JOB_SUMMARY_LIST]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_BERA_VERSION_LIST]);
			message.success(I18n.get('B.E.R.A. deleted successfully'));
		},
		onError: (err: AxiosError<Response>) => {
			message.error(I18n.get(err.response?.data?.message ?? 'Failed to delete the report'));
		}
	});
}
